import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as result from "./style.module.scss";

export const Result = ({ accessLimited }) => {
  return (
    <section className={`${result.result} ${main.sec}`}>
      <div className={main.containerMax}>
        <div className={main.blockTitle}>
          Проходя курс, вы
        </div>
        <div className={`row ${result.row}`}>
          <div className={`col col-3 ${result.col}`}>
            <div className={result.colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pictograms1.svg" alt="Запомните"/>
            </div>
            <div className={result.colDesc}>
              <b>Запомните</b> 252&nbsp;страны
              примерно за&nbsp;6&nbsp;часов
              и&nbsp;сможете показать их&nbsp;на&nbsp;карте
            </div>
          </div>
          <div className={`col col-3 ${result.col}`}>
            <div className={result.colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pictograms2.svg" alt="Научитесь"/>
            </div>
            <div className={result.colDesc}>
              <b>Научитесь</b> запоминать
              самые разные названия
            </div>
          </div>
          <div className={`col col-3 ${result.col}`}>
            <div className={result.colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pictograms3.svg" alt="Развлечетесь"/>
            </div>
            <div className={result.colDesc}>
              <b>Развлечетесь,</b> просматривая
              наши самые нескучные видео
            </div>
          </div>
          <div className={`col col-3 ${result.col}`}>
            <div className={result.colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pictograms4.svg" alt="Будете знать"/>
            </div>
            <div className={result.colDesc}>
              <b>Будете знать,</b> куда отправиться
              в&nbsp;путешествие
            </div>
          </div>
        </div>
        <div className={main.btnBlock}>
          <a href="#cost" className={main.mainBtn}>
            Хочу на курс
          </a>
        </div>
        { accessLimited && <p style={{ margin: "30px 0 0", textAlign: "center" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }
      </div>
    </section>
  );
};
